"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformDataHydrator = exports.IpsEvents = void 0;
const apiClient_1 = __importDefault(require("./apiClient"));
const dataHydrator_1 = __importDefault(require("./dataHydrator"));
const platformDataHydrator_1 = __importDefault(require("./platformDataHydrator"));
exports.PlatformDataHydrator = platformDataHydrator_1.default;
const uuid_1 = require("uuid");
const helper_1 = require("./helper");
const AID_PARAM_NAME = "ipse-aid";
const SOURCE = "frontend";
const SCHEMA_VERSION = "v1";
const POLLING_TIMEOUT = 5000;
class IpsEvents {
    constructor(platformDataHydrator, apiEndpoint, logger) {
        this.api = new apiClient_1.default(apiEndpoint, logger);
        this.logger = logger;
        this.platformDataHydrator = platformDataHydrator;
        this.dataHydrator = new dataHydrator_1.default(platformDataHydrator);
        this.events = [];
        this.anonymous_id = platformDataHydrator.resolveAnonymousId();
        this.platform = platformDataHydrator.resolvePlatform();
        this.pollForEvents();
    }
    collect(args) {
        const event = this.create(args);
        this.events.push(event);
        return event;
    }
    dispatch(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const event = this.create(args);
            const response = yield this.send(event);
            if (this.api.hasRequestFailed(response)) {
                this.logger.captureException(new Error("Dispatching event failed. Moving to events queue."), {
                    extra: {
                        event,
                        status: response.status,
                    }
                });
                this.events.push(event);
            }
            return event;
        });
    }
    create(args) {
        const event = {
            id: (0, uuid_1.v1)(),
            batch_id: (0, uuid_1.v1)(),
            anonymous_id: this.anonymous_id,
            contact_id: this.platformDataHydrator.resolveContactId(),
            session_id: this.platformDataHydrator.resolveSessionId(),
            schema_version: SCHEMA_VERSION,
            platform: this.platform,
            source: SOURCE,
            action: args.action,
            data_event: args.data_event,
            data_product: this.platformDataHydrator.resolveProductData(),
            data_split_test: this.platformDataHydrator.resolveSplitTestData(),
            data_web: this.dataHydrator.createDefaultDataWebProperty(),
            data_app: this.dataHydrator.createDefaultDataAppProperty(),
            data_user: this.dataHydrator.createDefaultDataUserProperty(),
            tracked_at: (0, helper_1.utcTimestamp)(new Date()),
            sent_at: (0, helper_1.utcTimestamp)(new Date()),
        };
        return Object.freeze(event);
    }
    add(event) {
        this.events.push(event);
    }
    all() {
        return this.events;
    }
    send(event) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.sendRequest([event]);
        });
    }
    flush() {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = this.events;
            const response = yield this.api.sendRequest(payload);
            if (this.api.hasRequestFailed(response)) {
                this.logger.captureException(new Error("Flushing events failed. Retrying on next poll."), {
                    extra: {
                        events: payload,
                        status: response.status,
                    }
                });
                return response;
            }
            this.events = [];
            return response;
        });
    }
    redirect(url) {
        window.location.replace(this.redirectUrl(url));
    }
    redirectUrl(url) {
        return url.includes(AID_PARAM_NAME)
            ? url
            : `${url}${url.includes("?") ? "&" : "?"}${AID_PARAM_NAME}=${this.anonymous_id}`;
    }
    pollForEvents() {
        return setInterval(() => {
            if (this.events.length) {
                this.flush();
            }
        }, POLLING_TIMEOUT);
    }
}
exports.IpsEvents = IpsEvents;
